module.exports = __webpack_public_path__ + "05b8b7a7a26e96ec2c34d72741ba9c71.MP3";